// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  position: relative;
  width: 100%;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  color: white;
  display: inline-block;
  font-family: "Varela Round";
  letter-spacing: 5px;
  color: #88888a;
  text-transform: uppercase;
  position: relative;
  text-align: center;
  height: 100%;
  animation-name: fadeIn;
  animation-duration: 0.7s;
  animation-delay: 0.8s;
  animation-timing-function: ease;
  animation-fill-mode: both;
  /* Stagger all the alignments */
  /* ---- VERTICAL LINES & THEIR ANIMATIONS ---- */
  /* these are the same for all animations */
  /* for each dripping letter, create the line, then animate down */
  /* stagger animation start times */
  /* keep a consistent "drip" speed */
  /* ---------- WHOLE PAGE ANIMATIONS ---------- */
  /* fade in to start */
  /* scroll the credits through they body window */
  /* stop at key points to see each credit */
}
.about > div * {
  position: relative;
}
.about img {
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  image-rendering: auto;
  z-index: 6;
}
.about .intro {
  width: 18em;
  margin-bottom: 500px;
  align-self: center;
  justify-self: center;
}
.about .beginning {
  margin-bottom: 500px;
  align-items: center;
  justify-items: center;
  line-height: 3em;
  display: flex;
  flex-direction: row;
}
.about .beginning_content {
  width: 70%;
  margin: auto;
  border-radius: 8px;
}
.about .beginning_img {
  opacity: 0;
  animation: slideLeft 3s 12s ease-in-out forwards;
  width: 50%;
}
.about img {
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  image-rendering: auto;
}
.about .story {
  width: 70%;
  margin-bottom: 500px;
  align-self: center;
  justify-self: center;
  line-height: 3em;
}
.about .now {
  width: 70%;
  align-self: center;
  justify-self: center;
  line-height: 3em;
}
.about h3 {
  font-size: 1rem;
  letter-spacing: 0.04rem;
  color: #ffc917;
}
.about span.supporting,
.about span.credentials {
  font-size: 0.63rem;
}
.about span.credentials {
  text-transform: lowercase;
}
.about span.hidden {
  /* Hide the letters that are created via animated*/
  /*visibility: hidden;*/
  /* Use color instead of visibility for IE */
  color: black;
  font-size: inherit;
  z-index: 0;
}
.about .intro h3 {
  left: 0;
}
.about .story {
  right: 0.95rem;
}
.about .story h2:last-of-type {
  right: 0.32rem;
}
.about .now {
  right: 1.38rem;
}
.about .now h3 {
  left: 0.2rem;
}
.about .now h2:last-of-type {
  left: 0.51rem;
}
.about h2::after {
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
  /* add z-index since we can't use visibility for the hidden letters*/
  z-index: 1;
  font-size: 0.5em;
}
.about .intro h2::after {
  /* --- The T in TRACHTENBERG --- */
  content: "";
  position: absolute;
  border: 1px solid #ffc917;
  border-radius: 4px;
  top: 0.191rem;
  left: 0;
  bottom: -11.32rem;
  animation-name: directedT;
  animation-duration: 10s;
  animation-delay: 2s;
}
.about .beginning h2::after {
  /* --- The T in TRACHTENBERG --- */
  content: "";
  position: absolute;
  border-left: 2px solid #f00000;
  top: 80%;
  left: 0;
  right: 20%;
  bottom: -11.32rem;
  animation-name: directedT;
  animation-duration: 10s;
  animation-delay: 22s;
  overflow: hidden;
}
@keyframes directedT {
  from {
    bottom: 0.191rem;
  }
  to {
    bottom: -39.32rem;
  }
}
@keyframes screenplayB {
  from {
    bottom: 0.19rem;
  }
  to {
    bottom: -0.82rem;
  }
}
@keyframes screenplayT {
  from {
    bottom: 0.18rem;
  }
  to {
    bottom: -0.822rem;
  }
}
@keyframes screenplayI {
  from {
    bottom: 0.18rem;
  }
  to {
    bottom: -11.324rem;
  }
}
@keyframes borderIt {
  from {
    opacity: 0;
    border: 0px solid #f3f3f3;
  }
  to {
    opacity: 1;
    border: 2px solid #f3f3f3;
  }
}
.about .story h2:first-of-type::after {
  /* --- The E in CAMPBELL --- */
  content: "";
  position: absolute;
  border-left: 0.109rem solid white;
  top: 0.114rem;
  left: -50%;
  bottom: -0.815rem;
  animation-name: storyE;
  animation-duration: 1.7s; /* KEEP CONSTANT */
  animation-delay: 52.6s;
}
@keyframes storyE {
  from {
    bottom: 0.18rem;
  }
  to {
    bottom: -0.815rem;
  }
}
.about .story h2:last-of-type::after {
  /* --- The T in MATT --- */
  content: "";
  position: absolute;
  border-left: 0.123rem solid white;
  top: 100%;
  left: 50%;
  bottom: -11.31rem;
  animation-name: storyT;
  animation-duration: 10s;
  animation-delay: 38.3s;
}
@keyframes storyT {
  from {
    bottom: 0.18rem;
  }
  to {
    bottom: -34.33rem;
  }
}
.about .now h2:first-of-type::after {
  /* --- The R in ABRAMS --- */
  content: "";
  position: absolute;
  top: 0.114rem;
  left: 2.98rem;
  bottom: -0.808rem;
  animation-name: producedR;
  animation-duration: 1.7s; /* KEEP CONSTANT */
  animation-delay: 18.9s;
}
@keyframes producedR {
  from {
    bottom: 0.18rem;
  }
  to {
    bottom: -0.808rem;
  }
}
.about .now h2:last-of-type::after {
  /* --- The I in LINDSEY --- */
  content: "";
  position: absolute;
  top: 0.12rem;
  left: 1.11rem;
  bottom: -5.5rem;
  animation-name: producedI;
  animation-duration: 4s;
  animation-delay: 20.5s;
  animation-timing-function: ease-in;
}
@keyframes producedI {
  from {
    bottom: 0.18rem;
  }
  to {
    bottom: -70vh;
  } /* = margin-bottom*/
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateX(200px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideLeft {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.about div.journey {
  animation-name: scroll;
  animation-duration: 50s;
  animation-delay: 3.6s;
  /* start and end very slowly, then go quickly */
  animation-timing-function: cubic-bezier(0.81, 0, 0.19, 1);
  animation-fill-mode: both;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 40vh;
  perspective: 8000px;
  background: rgb(0, 0, 0);
}
@keyframes scroll {
  /* Don't use calc inside translate - IE bug*/
  /* Instead, separate into two translateY values */
  /* Actually, cut the vh segment entirely, it messed up IE */
  33% {
    transform: translateY(-800px);
  }
  67% {
    transform: translateY(-1800px);
  }
  87% {
    transform: translateY(-2950px);
  }
  100% {
    transform: translateY(-5950px);
  }
}

.family {
  position: absolute;
  top: 0%;
  left: 0;
  right: 0;
  display: block;
  width: 50%;
  height: 100%;
  margin: 5% auto;
  padding: 0;
  border: none;
  border-radius: 10px;
  box-shadow: 0 30px 80px -20px rgba(0, 0, 0, 0.4), 0 10px 30px rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 18;
  font-family: "Varela Round";
  font-weight: 400;
  font-size: 30px;
  letter-spacing: 5px;
  opacity: 0;
  animation: fadeIn 1s 50.5s ease-in-out forwards;
}

.family:after {
  content: "";
  position: absolute;
  top: 0%;
  left: 0;
  width: 100%;
  height: 5px;
  background: #fff;
  animation: leftRight 20s infinite linear;
}

.photos {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  margin: 0;
}

.photos_items {
  position: absolute;
  left: 0;
  top: 0;
  width: 400%;
  animation: photoSlide 20s infinite ease-in-out;
}

.photos_item {
  position: relative;
  display: block;
  padding: 0;
  margin: 0;
  float: left;
  width: 25%;
}

.photos_item > img {
  height: 30em;
}

.photos_item span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 8vw;
  line-height: 8vw;
  text-indent: 2.5vw;
  font-size: 3vw;
  text-shadow: 5px 5px 50px rgba(0, 0, 0, 0.15);
  color: #fff;
}

@keyframes leftRight {
  0% {
    width: 0%;
  }
  30% {
    width: 100%;
  }
  31% {
    width: 0%;
  }
  66% {
    width: 100%;
  }
  67% {
    width: 0%;
  }
  99% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}
@keyframes photoSlide {
  0% {
    left: 0%;
  }
  30% {
    left: 0%;
  }
  31% {
    left: -100%;
  }
  66% {
    left: -100%;
  }
  67% {
    left: -200%;
  }
  99% {
    left: -200%;
  }
  100% {
    left: 0%;
  }
}
@media (min-width: 390px) {
  .family {
    display: none;
  }
  .beginning_content > h2, .story > h2, .now > h2 {
    font-size: 1em;
  }
  .beginning_content h2:first-of-type::after {
    animation: none;
  }
  .beginning_content h2:last-of-type::after {
    animation: none;
  }
  .story h2:first-of-type::after {
    animation: none;
  }
  .story h2:last-of-type::after {
    animation: none;
  }
  .now h2:first-of-type::after {
    animation: none;
  }
  .now h2:last-of-type::after {
    animation: none;
  }
  div.journey {
    animation: none;
  }
}
@media (min-width: 1024px) {
  .family {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/About/Styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,yCAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cCLS;EDMT,yBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,YAAA;EAGA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,yBAAA;EAsGA,+BAAA;EAyBA,gDAAA;EAEA,0CAAA;EASA,iEAAA;EACA,kCAAA;EACA,mCAAA;EAqKA,gDAAA;EAEA,qBAAA;EAiCA,gDAAA;EAkBA,0CAAA;AAhWF;AAJE;EACE,kBAAA;AAMJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;AAHJ;AAME;EAEE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AALJ;AAQE;EACE,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AANJ;AAQI;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AANN;AAUI;EACE,UAAA;EACA,gDAAA;EACA,UAAA;AARN;AAaE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAXJ;AAcE;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,UAAA;EAEA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,uBAAA;EACA,cCtGO;ADuFX;AAkBE;;EAEE,kBAAA;AAhBJ;AAmBE;EACE,yBAAA;AAjBJ;AAoBE;EACE,kDAAA;EACA,sBAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAlBJ;AAsBE;EACE,OAAA;AApBJ;AAuBE;EACE,cAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;AAyBE;EACE,cAAA;AAvBJ;AA0BE;EACE,YAAA;AAxBJ;AA2BE;EACE,aAAA;AAzBJ;AA+BE;EACE,sCAAA;EACA,yBAAA;EACA,oEAAA;EACA,UAAA;EACA,gBAAA;AA7BJ;AAoCE;EACE,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAlCJ;AAqCE;EACE,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE;IACE,gBAAA;EApCJ;EAsCE;IACE,iBAAA;EApCJ;AACF;AAuCE;EACE;IACE,eAAA;EArCJ;EAuCE;IACE,gBAAA;EArCJ;AACF;AAwCE;EACE;IACE,eAAA;EAtCJ;EAwCE;IACE,iBAAA;EAtCJ;AACF;AAyCE;EACE;IACE,eAAA;EAvCJ;EAyCE;IACE,kBAAA;EAvCJ;AACF;AA0CE;EACE;IACE,UAAA;IACA,yBAAA;EAxCJ;EA0CE;IACE,UAAA;IACA,yBAAA;EAxCJ;AACF;AA2CE;EACE,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA,EAAA,kBAAA;EACA,sBAAA;AAzCJ;AA4CE;EACE;IACE,eAAA;EA1CJ;EA4CE;IACE,iBAAA;EA1CJ;AACF;AA6CE;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;AA3CJ;AA8CE;EACE;IACE,eAAA;EA5CJ;EA8CE;IACE,iBAAA;EA5CJ;AACF;AA+CE;EACE,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,wBAAA,EAAA,kBAAA;EACA,sBAAA;AA7CJ;AAgDE;EACE;IACE,eAAA;EA9CJ;EAgDE;IACE,iBAAA;EA9CJ;AACF;AAiDE;EACE,6BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kCAAA;AA/CJ;AAkDE;EACE;IACE,eAAA;EAhDJ;EAkDE;IACE,aAAA;EAhDJ,EAiDI,mBAAA;AAhDN;AA8DE;EACE;IACE,UAAA;IACA,4BAAA;EA5DJ;EA+DE;IACE,UAAA;IACA,wBAAA;EA7DJ;AACF;AAgEE;EACE;IACE,UAAA;IACA,4BAAA;EA9DJ;EAiEE;IACE,UAAA;IACA,wBAAA;EA/DJ;AACF;AAmEE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,+CAAA;EACA,yDAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,wBAAA;AAlEJ;AAsEE;EAGE,4CAAA;EACA,iDAAA;EACA,2DAAA;EACA;IACE,6BAAA;EAtEJ;EAwEE;IACE,8BAAA;EAtEJ;EAyEE;IACE,8BAAA;EAvEJ;EA0EE;IACE,8BAAA;EAxEJ;AACF;;AAuFA;EACE,kBAAA;EACA,OAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gFAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EAEA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,UAAA;EACA,+CAAA;AAtFF;;AA0FA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAEA,wCAAA;AAvFF;;AA0FA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;AAvFF;;AA0FA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EAEA,8CAAA;AAvFF;;AA0FA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAvFF;;AA0FA;EACE,YAAA;AAvFF;;AA4FA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,6CAAA;EACA,WAAA;AAzFF;;AA2FA;EACE;IAAG,SAAA;EAvFH;EAwFA;IAAI,WAAA;EArFJ;EAsFA;IAAI,SAAA;EAnFJ;EAoFA;IAAI,WAAA;EAjFJ;EAkFA;IAAI,SAAA;EA/EJ;EAgFA;IAAI,WAAA;EA7EJ;EA8EA;IAAK,SAAA;EA3EL;AACF;AAgGA;EACG;IAAI,QAAA;EA/CL;EAgDA;IAAK,QAAA;EA7CL;EA8CA;IAAK,WAAA;EA3CL;EA4CA;IAAK,WAAA;EAzCL;EA0CA;IAAK,WAAA;EAvCL;EAwCA;IAAK,WAAA;EArCL;EAsCA;IAAM,QAAA;EAnCN;AACF;AE7eE;EFohBA;IACE,aAAA;EApCF;EAuCA;IACE,cAAA;EArCF;EAwCA;IACE,eAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,eAAA;EAxCF;EA2CA;IACE,eAAA;EAzCF;EA6CA;IACE,eAAA;EA3CF;EA8CA;IACE,eAAA;EA5CF;EA+CA;IACE,eAAA;EA7CF;AACF;AE9fE;EFgjBA;IACE,cAAA;EA/CF;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.about {\n  position: relative;\n  width: 100%;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);\n  color: white;\n  display: inline-block;\n  font-family: \"Varela Round\";\n  letter-spacing: 5px;\n  color: $bdt-gray;\n  text-transform: uppercase;\n  position: relative;\n\n  text-align: center;\n  height: 100%;\n  //   overflow: hidden;\n\n  animation-name: fadeIn;\n  animation-duration: 0.7s;\n  animation-delay: 0.8s;\n  animation-timing-function: ease;\n  animation-fill-mode: both;\n\n  & > div * {\n    position: relative;\n  }\n\n  // & > div > div:first-of-type {\n  //   margin-top: 40vh;\n  // }\n\n  // & > div > div:last-of-type {\n  //   margin-bottom: 50vh;\n  // }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-position: center center;\n    object-fit: cover;\n    image-rendering: auto;\n    z-index: 6;\n  }\n\n  .intro {\n    // margin-top: 10vh;\n    width: 18em;\n    margin-bottom: 500px;\n    align-self: center;\n    justify-self: center;\n  }\n\n  .beginning {\n    margin-bottom: 500px;\n    align-items: center;\n    justify-items: center;\n    line-height: 3em;\n    display: flex;\n    flex-direction: row;\n\n    &_content {\n      width: 70%;\n      margin: auto;\n      border-radius: 8px;\n      // animation: borderIt 2s 11.5s ease-in-out forwards;\n    }\n\n    &_img {\n      opacity: 0;\n      animation: slideLeft 3s 12s ease-in-out forwards;\n      width: 50%;\n      // height: 30em;\n    }\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-position: center center;\n    object-fit: cover;\n    image-rendering: auto;\n  }\n\n  .story {\n    width: 70%;\n    margin-bottom: 500px;\n    align-self: center;\n    justify-self: center;\n    line-height: 3em;\n  }\n\n  .now {\n    width: 70%;\n    // margin-bottom: 500px;\n    align-self: center;\n    justify-self: center;\n    line-height: 3em;\n  }\n\n  h3 {\n    font-size: 1rem;\n    letter-spacing: 0.04rem;\n    color: $bdt-gold;\n  }\n\n  span.supporting,\n  span.credentials {\n    font-size: 0.63rem;\n  }\n\n  span.credentials {\n    text-transform: lowercase;\n  }\n\n  span.hidden {\n    /* Hide the letters that are created via animated*/\n    /*visibility: hidden;*/\n    /* Use color instead of visibility for IE */\n    color: black;\n    font-size: inherit;\n    z-index: 0;\n  }\n\n  /* Stagger all the alignments */\n  .intro h3 {\n    left: 0;\n  }\n\n  .story {\n    right: 0.95rem;\n  }\n\n  .story h2:last-of-type {\n    right: 0.32rem;\n  }\n\n  .now {\n    right: 1.38rem;\n  }\n\n  .now h3 {\n    left: 0.2rem;\n  }\n\n  .now h2:last-of-type {\n    left: 0.51rem;\n  }\n\n  /* ---- VERTICAL LINES & THEIR ANIMATIONS ---- */\n\n  /* these are the same for all animations */\n  h2::after {\n    animation-timing-function: ease-in-out;\n    animation-fill-mode: both;\n    /* add z-index since we can't use visibility for the hidden letters*/\n    z-index: 1;\n    font-size: 0.5em;\n  }\n\n  /* for each dripping letter, create the line, then animate down */\n  /* stagger animation start times */\n  /* keep a consistent \"drip\" speed */\n\n  .intro h2::after {\n    /* --- The T in TRACHTENBERG --- */\n    content: \"\";\n    position: absolute;\n    border: 1px solid $bdt-gold;\n    border-radius: 4px;\n    top: 0.191rem;\n    left: 0;\n    bottom: -11.32rem;\n    animation-name: directedT;\n    animation-duration: 10s;\n    animation-delay: 2s;\n  }\n\n  .beginning h2::after {\n    /* --- The T in TRACHTENBERG --- */\n    content: \"\";\n    position: absolute;\n    border-left: 2px solid $bdt-red;\n    top: 80%;\n    left: 0;\n    right: 20%;\n    bottom: -11.32rem;\n    animation-name: directedT;\n    animation-duration: 10s;\n    animation-delay: 22s;\n    overflow: hidden;\n  }\n\n  @keyframes directedT {\n    from {\n      bottom: 0.191rem;\n    }\n    to {\n      bottom: -39.32rem;\n    }\n  }\n\n  @keyframes screenplayB {\n    from {\n      bottom: 0.19rem;\n    }\n    to {\n      bottom: -0.82rem;\n    }\n  }\n\n  @keyframes screenplayT {\n    from {\n      bottom: 0.18rem;\n    }\n    to {\n      bottom: -0.822rem;\n    }\n  }\n\n  @keyframes screenplayI {\n    from {\n      bottom: 0.18rem;\n    }\n    to {\n      bottom: -11.324rem;\n    }\n  }\n\n  @keyframes borderIt {\n    from {\n      opacity: 0;\n      border: 0px solid $bdt-white;\n    }\n    to {\n      opacity: 1;\n      border: 2px solid $bdt-white;\n    }\n  }\n\n  .story h2:first-of-type::after {\n    /* --- The E in CAMPBELL --- */\n    content: \"\";\n    position: absolute;\n    border-left: 0.109rem solid white;\n    top: 0.114rem;\n    left: -50%;\n    bottom: -0.815rem;\n    animation-name: storyE;\n    animation-duration: 1.7s; /* KEEP CONSTANT */\n    animation-delay: 52.6s;\n  }\n\n  @keyframes storyE {\n    from {\n      bottom: 0.18rem;\n    }\n    to {\n      bottom: -0.815rem;\n    }\n  }\n\n  .story h2:last-of-type::after {\n    /* --- The T in MATT --- */\n    content: \"\";\n    position: absolute;\n    border-left: 0.123rem solid white;\n    top: 100%;\n    left: 50%;\n    bottom: -11.31rem;\n    animation-name: storyT;\n    animation-duration: 10s;\n    animation-delay: 38.3s;\n  }\n\n  @keyframes storyT {\n    from {\n      bottom: 0.18rem;\n    }\n    to {\n      bottom: -34.33rem;\n    }\n  }\n\n  .now h2:first-of-type::after {\n    /* --- The R in ABRAMS --- */\n    content: \"\";\n    position: absolute;\n    top: 0.114rem;\n    left: 2.98rem;\n    bottom: -0.808rem;\n    animation-name: producedR;\n    animation-duration: 1.7s; /* KEEP CONSTANT */\n    animation-delay: 18.9s;\n  }\n\n  @keyframes producedR {\n    from {\n      bottom: 0.18rem;\n    }\n    to {\n      bottom: -0.808rem;\n    }\n  }\n\n  .now h2:last-of-type::after {\n    /* --- The I in LINDSEY --- */\n    content: \"\";\n    position: absolute;\n    top: 0.12rem;\n    left: 1.11rem;\n    bottom: -5.5rem;\n    animation-name: producedI;\n    animation-duration: 4s;\n    animation-delay: 20.5s;\n    animation-timing-function: ease-in;\n  }\n\n  @keyframes producedI {\n    from {\n      bottom: 0.18rem;\n    }\n    to {\n      bottom: -70vh;\n    } /* = margin-bottom*/\n  }\n\n  /* ---------- WHOLE PAGE ANIMATIONS ---------- */\n\n  /* fade in to start */\n  //  body {\n  //     animation-name: fadeIn;\n  //     animation-duration: .7s;\n  //     animation-delay: .8s;\n  //     animation-timing-function: ease;\n  //     animation-fill-mode: both;\n  //  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n      transform: translateX(200px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slideLeft {\n    0% {\n      opacity: 0;\n      transform: translateX(-20px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  /* scroll the credits through they body window */\n  div.journey {\n    animation-name: scroll;\n    animation-duration: 50s;\n    animation-delay: 3.6s;\n    /* start and end very slowly, then go quickly */\n    animation-timing-function: cubic-bezier(0.81, 0, 0.19, 1);\n    animation-fill-mode: both;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 40vh;\n\n    perspective: 8000px;\n    background: rgba(0, 0, 0, 1);\n  }\n\n  /* stop at key points to see each credit */\n  @keyframes scroll {\n    0% {\n    }\n    /* Don't use calc inside translate - IE bug*/\n    /* Instead, separate into two translateY values */\n    /* Actually, cut the vh segment entirely, it messed up IE */\n    33% {\n      transform: translateY(-800px) /*translateY(-30vh)*/;\n    }\n    67% {\n      transform: translateY(-1800px) /*translateY(-30vh)*/;\n    }\n\n    87% {\n      transform: translateY(-2950px) /*translateY(-30vh)*/;\n    }\n\n    100% {\n      transform: translateY(-5950px) /*translateY(-30vh)*/;\n    }\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n.family {\n  position: absolute;\n  top: 0%;\n  left: 0;\n  right: 0;\n  display: block;\n  width: 50%;\n  height: 100%;\n  margin: 5% auto;\n  padding: 0;\n  border: none;\n  border-radius: 10px;\n  box-shadow: 0 30px 80px -20px rgba(0,0,0,.4), 0 10px 30px rgba(0,0,0,.1);\n  background: rgba(0,0,0,.2);\n  overflow: hidden;\n  z-index: 18;\n\n  font-family: \"Varela Round\";\n  font-weight: 400;\n  font-size: 30px;\n  letter-spacing: 5px;\n\n  opacity: 0;\n  animation: fadeIn 1s 50.5s ease-in-out forwards;\n\n}\n\n.family:after {\n  content: \"\";\n  position: absolute;\n  top: 0%;\n  left:0;\n  width: 100%;\n  height: 5px;\n  background: #fff;\n  -webkit-animation: leftRight 20s infinite linear;\n  animation: leftRight 20s infinite linear;\n}\n\n.photos {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  overflow: hidden;\n  margin: 0;\n}\n\n.photos_items {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 400%;\n  -webkit-animation: photoSlide 20s infinite ease-in-out;\n  animation: photoSlide 20s infinite ease-in-out;\n}\n\n.photos_item {\n  position: relative;\n  display: block;\n  padding: 0;\n  margin: 0;\n  float: left;\n  width: 25%;\n}\n\n.photos_item > img {\n  height: 30em;\n  // width: 30em;\n}\n\n\n.photos_item span {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 8vw;\n  line-height: 8vw;\n  text-indent: 2.5vw;\n  font-size: 3vw;\n  text-shadow: 5px 5px 50px rgba(0,0,0,.15);\n  color: #fff;\n}\n@keyframes leftRight{\n  0%{width:0%;}\n  30%{width:100%;}\n  31%{width:0%;}\n  66%{width:100%;}\n  67%{width:0%;}\n  99%{width:100%;}\n  100%{width:0%;}\n} \n@-webkit-keyframes leftRight{\n  0%{width:0%;}\n  30%{width:100%;}\n  31%{width:0%;}\n  66%{width:100%;}\n  67%{width:0%;}\n  99%{width:100%;}\n  100%{width:0%;}\n} \n\n@-webkit-keyframes photoSlide{\n   0% {left: 0%;}\n  30% {left: 0%;}\n  31% {left: -100%;}\n  66% {left: -100%;}\n  67% {left: -200%;}\n  99% {left: -200%;}\n  100% {left: 0%;}\n}\n\n@keyframes photoSlide{\n   0% {left: 0%;}\n  30% {left: 0%;}\n  31% {left: -100%;}\n  66% {left: -100%;}\n  67% {left: -200%;}\n  99% {left: -200%;}\n  100% {left: 0%;}\n}\n\n\n@include screen-sm {\n  .family {\n    display: none;\n  }\n\n  .beginning_content > h2, .story > h2, .now > h2 {\n    font-size: 1em;\n  }\n\n  .beginning_content h2:first-of-type::after {\n    animation: none;\n  }\n\n  .beginning_content h2:last-of-type::after {\n    animation: none;\n  }\n\n  .story h2:first-of-type::after {\n    animation: none;\n  }\n\n  .story h2:last-of-type::after {\n    animation: none;\n  }\n\n\n  .now h2:first-of-type::after {\n    animation: none;\n  }\n\n  .now h2:last-of-type::after {\n    animation: none;\n  }\n\n  div.journey {\n    animation: none;\n  }\n\n}\n\n@include screen-lg {\n  .family {\n    display: block;\n  }\n}","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
